const getters = {
    getUserCartItem:(state) => state.cartItem,
};
export default getters;